import { getLocalStorage, setLocalStorage } from 'utils/CommonFunction';
import constants from 'constants/index';
import { callRefreshToken } from 'apis/Auth';

export const parseJwt = (token) => {
  if (!token) {
    return false;
  }

  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(window.atob(base64).split('')
    .map((c) => `%${ (`00${ c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''));

  return JSON.parse(jsonPayload);
};

export const handleToken = async (refreshToken) => new Promise((resolve, reject) => {
  const expTimeToken = getLocalStorage('expTimeToken_mcv');
  const expTimeRefreshToken = getLocalStorage('expTimeRefreshToken_mcv');
  const currentTime = new Date().getTime();

  if (expTimeToken < currentTime) {
    if (currentTime < expTimeRefreshToken) {
      callRefreshToken({ refreshToken }).then((res) => {
        const data = res.data ? res.data : null;
        const decodeTokenNew = parseJwt(data && data.token);
        const newExpTimeToken = new Date().getTime() + constants.EXPIRE_TIME_TOKEN;
        const newExpTimeRefreshToken = new Date().getTime() + constants.EXPIRE_TIME_REFRESH_TOKEN;

        setLocalStorage('token_mcv', data && data.token);
        setLocalStorage('refreshToken_mcv', data && data.refreshToken);
        setLocalStorage('username_mcv', decodeTokenNew.Username);
        setLocalStorage('lastLogin_mcv', decodeTokenNew.LastTimeLogin);
        setLocalStorage('expTimeToken_mcv', newExpTimeToken);
        setLocalStorage('expTimeRefreshToken_mcv', newExpTimeRefreshToken);

        const responseToken = {
          token: data && data.token,
          refreshToken: data && data.refreshToken,
        };

        resolve(responseToken);
      }).catch((err) => {
        reject(err);
      });
    } else {
      resolve(false);
    }
  } else {
    resolve(true);
  }
});
